export const CONTENT_ID = 'content';
export const FOOTNOTES_CONTAINER_ID = 'footnotes-container';
export const ONLOAD_FOOTNOTE_SCROLL_DELAY = 1000;
